import { Suspense } from 'react';
import { ToDoTableContent } from './ToDoTableContent';
import { Abteilung, Arbeitsbereich } from '@/domain/arbeitszeiten/entities';
import { ToDoRowModel } from './entities/Entities';

export function ToDoTable({
  mitarbeiterFilter = '',
  arbeitsbereichFilter,
  abteilungFilter,
  data,
}: {
  mitarbeiterFilter?: string;
  arbeitsbereichFilter: Arbeitsbereich[];
  abteilungFilter: Abteilung[];
  data: ToDoRowModel[];
}) {
  return (
    <Suspense>
      <ToDoTableContent
        mitarbeiterFilter={mitarbeiterFilter}
        arbeitsbereichFilter={arbeitsbereichFilter}
        abteilungFilter={abteilungFilter}
        data={data}
      />
    </Suspense>
  );
}
